import { HTTP } from '@/http-common'

function getAddress (addressId) {
  return HTTP.get('/addresses/' + addressId)
}

function addAddress (addressData) {
  let data = JSON.stringify(addressData)

  return HTTP.post('/addresses', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateAddress (addressData) {
  let data = JSON.stringify(addressData)

  return HTTP.put('/addresses/' + addressData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteAddress (addressId) {
  return HTTP.delete('/addresses/' + addressId)
}

export { getAddress, addAddress, updateAddress, deleteAddress }



// WEBPACK FOOTER //
// ./src/services/address.service.js